import styled from 'styled-components'
import ProductInfoPage from 'components/desktop/page/ProductInfo'

const ProductInfoMobilePage = styled(ProductInfoPage)``

export default ProductInfoMobilePage
